
import PropTypes from "prop-types";

import {Dropdown} from "primereact/dropdown";
import {useEffect, useState} from "react";
import {useSpinner} from "../../context/SpinnerContext";
import {axiosInstance} from "../../utilities/AxiosConfig";
import {notify} from "../toast";





export function LocationSelect(props) {



 // Dependencies included for best practice

    const handleChange = (event) => {
        const myValue =props.locationList.find(x=>x.name===event.target.value)
        props.setLocation(myValue);

    }

        return (
            <>


                    <Dropdown value={props.location.name} onChange={handleChange} options={props.locationList}
                              optionLabel="name" optionValue="name"
                              placeholder="Select a Location"
                              className="w-full mt-1 md:w-14rem font-size:0.5rem h-2rem align-items-center"
                              disabled={props.disable}/>


            </>

        );

}

LocationSelect.propTypes = {
    locationList: PropTypes.array,
    location: PropTypes.object.isRequired,
    setLocation: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,

}


